const PERSONAL_EMAIL_DOMAINS = new Set([
    'gmail.com',
    'googlemail.com',
    'outlook.com',
    'hotmail.com',
    'live.com',
    'msn.com',
    'yahoo.com',
    'ymail.com',
    'rocketmail.com',
    'icloud.com',
    'me.com',
    'mac.com',
    'proton.me',
    'protonmail.com',
    'pm.me'
]);

export function emailDomain(email) {
    const at = String(email || '').lastIndexOf('@');
    if (at < 0) return '';
    return email.slice(at + 1).trim().toLowerCase();
}

export function isPersonalEmailDomain(email) {
    const domain = emailDomain(email);
    return PERSONAL_EMAIL_DOMAINS.has(domain);
}
